import React, {useState, useEffect} from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from '../../../presentation/dropdown/DropdownToggle';
import DropdownMenu from '../../../presentation/dropdown/DropdownMenu';

import './DropdownEditRelation.css';

const DropdownEditRelation = (props) => {
  const [words, setWords] = useState(props.words);
  const [deleteWords, setDeleteWords] = useState([]);

  const handleApplyBtn = () => {
    const newWords = words.filter(item => {
      return deleteWords.findIndex(deleteItem=> item.text == deleteItem.text) === -1;
    });
    props.handleWords(newWords);
  }

  const handleCancelBtn = () => {
    setDeleteWords([])
  }

  const handleDeleteBtn = (words) => {
    setDeleteWords(wordsArray => [...wordsArray, words]);
  }

  useEffect(()=>{
    setWords(props.words);
  }, [props.words])

  useEffect(() => {
    setDeleteWords([]);
  }, [words])

  return (
    // <Dropdown id="wordcloud-edit" style={{marginTop: "19px"}}>
    <Dropdown id="wordcloud-edit" style={{paddingTop:'7px', display:'inline-block'}}>
      <Dropdown.Toggle hrefValue="" as={DropdownToggle} id="wordcloud-edit-toggle">
        {/* <a className="button purple_line" style={{margin: "10px 10px 0px 0px"}}>
          Edit
        </a> */}
        <div className="button purple_line">{props.toggle}</div>
      </Dropdown.Toggle>
      <Dropdown.Menu as={DropdownMenu}>
        <div className="wordList">
          <div className="wordSetting">
            {words.filter(item => {
              return deleteWords.findIndex(deleteItem=> item.text == deleteItem.text) === -1;
            })
            .map(item=>{
              return(
                <div className="word-row">
                  <div className="word-text-value">
                    <div className="word-text">
                      {item.text}
                    </div>
                    <div>
                      {`(${item.value})`}
                    </div>
                  </div>
                  <div className="word-delete">
                    <span style={{cursor:"pointer"}} onClick={()=>handleDeleteBtn({text: item.text, value: item.value})}>
                      x
                    </span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <Dropdown.ItemText className="wordSettingBtn" style={{padding: "0"}}>
          <Dropdown.Item onClick={handleCancelBtn} style={{width: "auto"}} className="button purple_line">목록 초기화</Dropdown.Item>
            &nbsp;
          <Dropdown.Item onClick={handleApplyBtn} style={{width: "auto"}} className="button purple_line">적용</Dropdown.Item>
        </Dropdown.ItemText>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DropdownEditRelation;